// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__21pok","buttons":"PendingPaymentAlert_buttons__3_kZo"};